export const products = [
    {
        rootDevice: "caas",
        deviceName: "Intel x86",
    },
    {
        rootDevice: "cm4io",
        deviceName: "Raspberry Pi Compute Module 4",
    },
    {
        rootDevice: "cm5io",
        deviceName: "Raspberry Pi Compute Module 5",
    },
    {
        rootDevice: "imx8mm",
        deviceName: "NXP i.MX8 MM",
    },
    {
        rootDevice: "imx8mn",
        deviceName: "NXP i.MX8 MN",
    },
    {
        rootDevice: "imx8mp",
        deviceName: "NXP i.MX8 MP",
    },
    {
        rootDevice: "imx8mq",
        deviceName: "NXP i.MX8 MQ",
    },
    {
        rootDevice: "rpi4",
        deviceName: "Raspberry Pi 4B",
    },
    {
        rootDevice: "rpi5",
        deviceName: "Raspberry Pi 5",
    },
    {
        rootDevice: "rockpi4b",
        deviceName: "Rock 4B",
    },
    {
        rootDevice: "rockpi5b",
        deviceName: "Rock 5",
    },
] as const;

export const resolveHardwareName = (codename: string): string => {
    const match = products.find((product) => product.rootDevice === codename);
    return match?.deviceName ?? (codename.trim() || "-");
};

export const androidVersionOptions: Record<string, string[]> = {
    caas: ["13", "14", "15", "16", "17"],
    cm4io: ["11", "13", "14", "15", "16", "17"],
    cm5io: ["14", "15", "16", "17"],
    rpi4: ["11", "13", "14", "15", "16", "17"],
    rpi5: ["14", "15", "16", "17"],
    rockpi4b: ["11"],
    rockpi5b: ["12"],
    imx8mp: ["11", "12", "13", "14"],
    imx8mm: ["11", "12", "13", "14"],
    imx8mn: ["11", "12", "13", "14"],
    imx8mq: ["11", "12", "13", "14"],
};
